import { render, staticRenderFns } from "./GitAplications.vue?vue&type=template&id=03bc881a&scoped=true&"
import script from "./GitAplications.vue?vue&type=script&lang=js&"
export * from "./GitAplications.vue?vue&type=script&lang=js&"
import style0 from "./GitAplications.vue?vue&type=style&index=0&id=03bc881a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc881a",
  null
  
)

export default component.exports